import React from 'react';
import { Link, Typography } from '@mui/material';

import { websiteUrl } from '../../env';
import { formatExternalUrl } from '../../utils/parsing';

export function isRecommendDeepLink(href?: string): boolean {
    const raw = href ?? (typeof window !== 'undefined' ? window.location.href : '');
    if (!raw) return false;
    try {
        const url = new URL(raw, 'http://localhost');
        return (
            url.searchParams.get('recommend') === 'true'
            && /^\/company-profile\/[^/]+\/?$/.test(url.pathname)
        );
    } catch {
        return false;
    }
}

export default function RecommendBlockedNotice({ reason }: { reason: 'pending' | 'locked' }) {
    if (!isRecommendDeepLink()) {
        return null;
    }

    const message = reason === 'pending'
        ? 'Rekommendationen kunde inte sparas. Du kan rekommendera åkerier när ditt konto är aktiverat.'
        : 'Rekommendationen kunde inte sparas. Du kan inte rekommendera åkerier medan kontot är låst.';

    const homeHref = websiteUrl
        ? formatExternalUrl(String(websiteUrl).replace(/\/$/, ''))
        : null;

    return (
        <Typography color="secondary.main" sx={{ textAlign: 'center', mb: 2, mt: 2 }}>
            {message}
            {homeHref && (
                <>
                    {' '}
                    <Link href={homeHref} color="inherit" underline="always">
                        Tillbaka till hemsidan
                    </Link>
                    .
                </>
            )}
        </Typography>
    );
}
